import type { FaireProductEntity } from "../../entity_types/product";

export const p_9iu6e71o: FaireProductEntity = {
  token: "p_9iu6e71o",
  type: "product",
  name: "Happily Ever After Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/108f09be90756b8d4fcf5f1e85a33c7b223ccc8c5987d6ce768767f6b2bd1c5c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c3c088b80ac7c93632222bf9a821273a53fbcbb9f5862424fd3278a0e7b7c6d.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:14.448Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
